<template>
  <router-link v-if="count > 0 && to" class="menu-attention-badge" :to="destination" :replace="isCurrentDestination"
    v-b-tooltip.hover :title="title" :aria-label="title">
    {{ displayCount }}
  </router-link>
  <button v-else-if="count > 0" type="button" class="menu-attention-badge"
    v-b-tooltip.hover :title="title" :aria-label="title" @click="$emit('click')">
    {{ displayCount }}
  </button>
</template>

<script>
import { formatAttentionCount } from '../utils/menuAttention';

export default {
  name: 'MenuAttentionBadge',
  props: {
    count: { type: Number, default: 0 },
    title: { type: String, default: '' },
    to: { type: [Object, String], default: null },
  },
  emits: ['click'],
  computed: {
    displayCount() { return formatAttentionCount(this.count); },
    // Re-selecting a badge must restore its filter even after a manual search on that page.
    destination() { return typeof this.to === 'object' && this.to ? { ...this.to, force: true } : this.to; },
    isCurrentDestination() { return this.to && this.$router.resolve(this.to).fullPath === this.$route.fullPath; },
  },
};
</script>
